<template>
  <div class="page-login text-center pt-2 pr-3 pb-3 pl-3">
    <div class="toolbar text-left mb-4">
      <a href="/" class="btn-back" @click.prevent="gotoRoute('Main')">
        <b-icon icon="chevron-left" class="mr-1"/>
        {{ $t("Back") }}</a>
    </div>

    <div class="mb-5 d-block logo">
      <img src="images/full-logo.png" alt="logo" style="max-width: 100%; width: 300px"/>
    </div>

    <ValidationObserver ref="form" tag="form" class="d-block ml-auto mr-auto" style="width: 400px; max-width: 100%"
                        @submit.prevent="logIn()">
      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input v-model="formData.username" :placeholder="$t('Mobile / Email')" :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-mail.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-input-group class="input-group-trans">
            <b-form-input type="password" v-model="formData.password" ref="txtPassword" :placeholder="$t('Password')"
                          :disabled="loading"/>
            <b-input-group-append>
              <b-input-group-text>
                <img src="images/ico-lock.png"/>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <div class="validate-error">{{ errors[0] }}</div>
        </ValidationProvider>
      </b-form-group>

      <b-form-group class="mb-1">
        <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">{{
            $t("Log In")
          }}
        </b-button>
      </b-form-group>
      <div class="d-flex justify-content-between">
        <a href="/" @click.prevent="gotoRoute('SignUp')">{{$t("Sign Up")}}</a>
        <a href="/" @click.prevent="gotoRoute('PasswordRecovery')">{{$t("Forgot password?")}}</a>
      </div>
    </ValidationObserver>
    <PanelLoading :show="loading" message="Authenticating..."/>
  </div>
</template>

<script>
import authenticateService from "../services/authenticate_service";
import dialogHelper from "../helpers/dialog_helper";
import appHelper from "../helpers/app_helper";
import jwt from "jsonwebtoken";

export default {
  name: "LogIn",
  data: function () {
    return {
      loading: false,
      formData: {
        username: "",
        password: ""
      }
    }
  },
  beforeCreate() {
    this.setTitle("Log In");
  },
  methods: {
    gotoRoute: function (routeName = "Main") {
      if (this.$route.query.routeName)
        routeName = this.$route.query.routeName;

      this.$router.push({name: routeName, query: {routeName:"LogIn"}});
    },
    logIn: async function () {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading == true)
        return;

      this.loading = true;
      const response = await authenticateService.logIn(this.formData);
      this.loading = false;

      if (!response) return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        this.formData.password = "";
        this.$refs.txtPassword.$el.focus();
        return;
      }

      let responseData = JSON.parse(response.substr(3));
      await this.$store.dispatch("setUserInfo", {
        username: this.formData.username,
        password: this.formData.password,
        tempPwd: responseData.TempPwd,
        transId: responseData.TransID,
        storeLink: responseData.StoreLink,
        deviceId: appHelper.settings.macAddress
      })

      await appHelper.setSetting("loginInfo", {
        username: this.formData.username,
        password: jwt.sign(this.formData.password, this.formData.username, {algorithm:"HS256"})
      })

      await this.$store.dispatch("setMainButtons", responseData.ButtonsLable);
      this.gotoRoute("Home");
    }
  }
}
</script>